import React, { useState, useEffect } from "react"
import _ from 'lodash'
import { field_attrs } from "components/table/lib/column-field"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"

const PercentEGR = (props: {rowData: [], field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null
  }
  const [data, setData] = useState<object|null>(props.rowData)

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'percentEGR') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val: number, field: string):void {
    let localCache = _.cloneDeep(data);
    let nextData = _.cloneDeep(props.rowData)
    nextData[field] = localCache[field] = val
    setData(localCache)

    nextData["lineitemdetail"] = {state: "percentEGR"}
    nextData["inputtype"] = "percentEGR"
    nextData["amttype"] = null
    nextData["areaid"] = null
    nextData["inflationdetail"] = null

    props.persist(nextData, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('lineitem')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Percent</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="amt" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default PercentEGR
